import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_header = _resolveComponent("base-header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_header, { type: "white" }),
    _createElementVNode("main", {
      class: _normalizeClass(["layout__main dashboard-page documents dashboard__popup--open", [_ctx.routerModel.router.currentRoute.meta.mainClass]]),
      id: "mainWrapper"
    }, [
      _createVNode(_component_router_view),
      _createVNode(_component_router_view, { name: "popup" })
    ], 2)
  ], 64))
}